import Modal from "react-bootstrap/Modal";
import Lottie from "react-lottie";
import * as animationData from "../../assets/icons/loading.json";

interface ProductDetailModalProps {
  open: boolean;
  onClose: () => void;
  message: string;
}

const RedirectModal = ({ open, onClose, message }: ProductDetailModalProps) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Modal
      show={open}
      onHide={() => onClose()}
      className="center-screen-modal redirect-modal"
    >
      <Modal.Body>
        <div className="modal-detail redirect-modal">
          <Lottie options={defaultOptions} height={56.67} width={100} />

          <span className="modal-text">{message}</span>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RedirectModal;
